export var category_icons = {
    Uncategorized: "fa-question",
    Accommodation: "fa-images",
    "Anti-Suppression": "fa-circle-notch",
    "Gross & Fine Motor": "fa-table-tennis",
    Oculomotor: "fa-eye",
    Syntonics: "fa-glasses",
    Vergence: "fa-exchange-alt",
    "Visual Perception": "fa-cubes",
    "Visual Processing": "fa-brain",
    "Visual-Vestibular": "fa-child",
    "Primitive Reflexes": "fa-baby",
    "Laterality / Directionality": "fa-arrows-alt",
    "Disabled": "mdi-circle-off-outline",
    Testing: "fa-tasks",

    // VisionX Icons
    "Performance Series": "fa-solid fa-fire",
    "Wall Series": "fa-solid fa-block-brick",
    "Juggling Series": "fa-solid fa-ball-pile",
    "Computer Series": "fa-solid fa-laptop",
    "Balance Series": "fas fa-balance-scale-right",
    "Eye Patch Series": "fas fa-skull-crossbones",
    "Saccadic Strip Series": "fas fa-grip-lines-vertical"
};

// Function to get category icon, handling custom categories
export function get_category_icon(category_id, custom_categories = []) {
    // Check if it's a custom category (UUID)
    if (category_id && category_id.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
        const custom_category = custom_categories.find(cat => cat.id === category_id);
        return custom_category ? custom_category.icon : 'mdi-folder';
    }
    
    // Return built-in category icon
    return category_icons[category_id] || 'fa-question';
}

// Function to get category name, handling custom categories
export function get_category_name(category_id, custom_categories = []) {
    // Check if it's a custom category (UUID)
    if (category_id && category_id.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)) {
        const custom_category = custom_categories.find(cat => cat.id === category_id);
        return custom_category ? custom_category.name : 'Unknown Category';
    }
    
    // Return built-in category name
    return category_id || 'Uncategorized';
}

export function category_items(context, array_value = false, app = "nvt", custom_categories = []) {
    let items = [
        { text: context.$t("common.accommodation"), value: "Accommodation" },
        { text: context.$t("common.anti_suppression"), value: "Anti-Suppression" },
        {
            text: context.$t("common.gross_fine_motor"),
            value: "Gross & Fine Motor",
        },
        { text: context.$t("common.oculomotor"), value: "Oculomotor" },
        {
            text: context.$t("common.primitive_reflexes"),
            value: "Primitive Reflexes",
        },
        { text: context.$t("common.syntonics"), value: "Syntonics" },
        { text: context.$t("common.testing"), value: "Testing" },
        { text: context.$t("common.vergence"), value: "Vergence" },
        {
            text: context.$t("common.visual_perception"),
            value: "Visual Perception",
        },
        {
            text: context.$t("common.visual_processing"),
            value: "Visual Processing",
        },
        {
            text: context.$t("common.visual_vestibular"),
            value: "Visual-Vestibular",
        },
        {
            text: context.$t("common.laterality_directionality"),
            value: "Laterality / Directionality",
        },
    ];

    // Add custom categories
    if (custom_categories && custom_categories.length > 0) {
        const custom_items = custom_categories.map(category => ({
            text: category.name,
            value: category.id // Use UUID for custom categories
        }));
        items = items.concat(custom_items);
    }

    if (app == "visionx") {
        let additional_items = [
            { text: context.$t("categories.performance_series"), value: "Performance Series" },
            { text: context.$t("categories.wall_series"), value: "Wall Series" },
            { text: context.$t("categories.juggling_series"), value: "Juggling Series" },
            { text: context.$t("categories.computer_series"), value: "Computer Series" },
            { text: context.$t("categories.balance_series"), value: "Balance Series" },
            { text: context.$t("categories.eye_patch_series"), value: "Eye Patch Series" },
            { text: context.$t("categories.saccadic_strip_series"), value: "Saccadic Strip Series" },
        ];
        items = items.concat(additional_items);
    }

    items.sort(function (a, b) {
        return a.text.localeCompare(b.text, context.$i18n ? context.$i18n.locale : undefined);
    });

    // Value should be an array, not a single-value
    if (array_value) {
        items = items.map((item) => {
            item.value = [item.value];
            return item;
        });
    }

    return items;
}
